<template>
  <div class="row mt-4">
    <!-- Gráfico -->
    <div class="col-lg-6">
      <div class="card p-3">
        <h5 class="mb-3">Totales Terminados por Producto</h5>

        <!-- Filtros -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label for="fecha_inicio" class="form-label">Fecha inicio</label>
            <input
              id="fecha_inicio"
              type="date"
              class="form-control"
              v-model="fecha_inicio"
            />
          </div>
          <div class="col-md-6">
            <label for="fecha_fin" class="form-label">Fecha fin</label>
            <input
              id="fecha_fin"
              type="date"
              class="form-control"
              v-model="fecha_fin"
            />
          </div>
        </div>

        <canvas id="totalesChart"></canvas>

        <ul class="mt-3">
          <li v-for="t in totales" :key="t.inventory_id">
            <strong>Producto {{ t.inventory_id }}:</strong>
            {{ t.total_general }} unidades
          </li>
        </ul>
      </div>
    </div>

    <!-- Listado detallado -->
    <div class="col-lg-6">
      <div class="card p-3">
        <h5 class="mb-3">Detalle de Producción</h5>
        <div class="table-responsive">
        <table class="table table-sm ">
          <thead>
            <tr>
              <th>ID</th>
              <th>Producto</th>
              <th>Primera</th>
              <th>Segunda</th>
              <th>Tercera</th>
              <th>Total</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in listado.data" :key="item.id">
              <td>{{ item.id }}</td>
              <td>{{ item.inventory?.name || item.inventory_id }}</td>
              <td>{{ item.primera }}</td>
              <td>{{ item.segunda }}</td>
              <td>{{ item.tercera }}</td>
              <td>{{ item.primera + item.segunda + item.tercera }}</td>
              <td>{{ formatDate(item.created_at) }}</td>
            </tr>
          </tbody>
        </table>
        </div>

        <!-- Paginación -->
        <div class="d-flex justify-content-between align-items-center mt-2">
          <button
            class="btn btn-sm btn-secondary"
            @click="prevPage"
            :disabled="listado.current_page === 1"
          >
            Anterior
          </button>
          <span>Página {{ listado.current_page }} de {{ listado.last_page }}</span>
          <button
            class="btn btn-sm btn-secondary"
            @click="nextPage"
            :disabled="listado.current_page === listado.last_page"
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";
Chart.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default {
  name: "TotalesTerminados",
  data() {
    const hoy = new Date();
    const hace15 = new Date();
    hace15.setDate(hoy.getDate() - 15);

    const formatDate = (d) => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    };

    return {
      fecha_inicio: formatDate(hace15),
      fecha_fin: formatDate(hoy),
      totales: [],
      listado: { data: [], current_page: 1, last_page: 1 },
      chartInstance: null,
    };
  },
  watch: {
    fecha_inicio() {
      this.fetchTotales();
    },
    fecha_fin() {
      this.fetchTotales();
    },
  },
  methods: {
    async fetchTotales(page = 1) {
      try {
        const params = {
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          page,
        };
        const res = await this.$store.dispatch("analitycs/getTerminados", params);
        const data = res.data;

        this.totales = data.totales || [];
        this.listado = data.listado || { data: [] };

        this.renderChart();
      } catch (error) {
        console.error("Error cargando totales terminados:", error);
      }
    },

    renderChart() {
      if (this.chartInstance) this.chartInstance.destroy();

      const ctx = document.getElementById("totalesChart");

      const labels = this.totales.map(() => `Terminados`);
      const dataPrimera = this.totales.map((t) => t.total_primera);
      const dataSegunda = this.totales.map((t) => t.total_segunda);
      const dataTercera = this.totales.map((t) => t.total_tercera);

      this.chartInstance = new Chart(ctx, {
        type: "bar",
        data: {
          labels,
          datasets: [
            { label: "Primera", data: dataPrimera, backgroundColor: "#36A2EB" },
            { label: "Segunda", data: dataSegunda, backgroundColor: "#FFCE56" },
            { label: "Tercera", data: dataTercera, backgroundColor: "#FF6384" },
          ],
        },
        options: {
          responsive: true,
          plugins: { legend: { position: "bottom" } },
          scales: {
            y: { beginAtZero: true },
          },
        },
      });
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString("es-ES");
    },

    nextPage() {
      if (this.listado.current_page < this.listado.last_page) {
        this.fetchTotales(this.listado.current_page + 1);
      }
    },
    prevPage() {
      if (this.listado.current_page > 1) {
        this.fetchTotales(this.listado.current_page - 1);
      }
    },
  },
  mounted() {
    this.fetchTotales();
  },
};
</script>

<style scoped>
.table {
  font-size: 0.85rem;
}
</style>
